<div class="header">
  <img src="assets/icons/inlite_logo.svg">
</div>
